/**
 * Login configuration based on environment variables
 * Controls which login methods are available in the application
 */

export interface LoginConfig {
  enableEmailLogin: boolean;
  enableGoogleLogin: boolean;
  enableMicrosoftLogin: boolean;
  showDemoCredentials: boolean;
}

/**
 * Parse environment variable to boolean
 * Accepts: 'true', '1', 'yes' as true, everything else as false
 */
const parseEnvBoolean = (value: string | undefined, defaultValue: boolean = false): boolean => {
  if (!value) return defaultValue;
  return value.toLowerCase() === 'true' || value === '1' || value.toLowerCase() === 'yes';
};

/**
 * Get login configuration from environment variables
 */
export const getLoginConfig = (): LoginConfig => {
  return {
    enableEmailLogin: parseEnvBoolean(import.meta.env.VITE_ENABLE_EMAIL_LOGIN, false),
    enableGoogleLogin: parseEnvBoolean(import.meta.env.VITE_ENABLE_GOOGLE_LOGIN, false),
    enableMicrosoftLogin: parseEnvBoolean(import.meta.env.VITE_ENABLE_MICROSOFT_LOGIN, true),
    showDemoCredentials: parseEnvBoolean(import.meta.env.VITE_SHOW_DEMO_CREDENTIALS, false),
  };
};

/**
 * Check if at least one login method is enabled
 */
export const hasAnyLoginMethod = (config: LoginConfig): boolean => {
  return config.enableEmailLogin || config.enableGoogleLogin || config.enableMicrosoftLogin;
};

/**
 * Check if OAuth methods are enabled
 */
export const hasOAuthMethods = (config: LoginConfig): boolean => {
  return config.enableGoogleLogin || config.enableMicrosoftLogin;
};

